import { render } from "./HourGrid.vue?vue&type=template&id=0d1d7e2a&scoped=true"
import script from "./HourGrid.vue?vue&type=script&lang=js"
export * from "./HourGrid.vue?vue&type=script&lang=js"

import "./HourGrid.vue?vue&type=style&index=0&id=0d1d7e2a&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1d7e2a"]])

export default __exports__